/* istanbul ignore file */

import { AsyncRouteProps } from 'src/components/AsyncRoute/AsyncRoute';

enum LandingPagePaths {
  GUARANTEE = '/guarantee',
  CONVENIENCE = '/convenience',
  POINTS_OLD = '/points',
  POINTS = '/rewards',
  CAMPUS = '/about/campus',
  GOLD_DAYS = '/gold-days',
}

export const LandingPageRoutes: { [key: string]: AsyncRouteProps } = {
  [LandingPagePaths.GUARANTEE]: {
    module: () => import('./guarantee/GuaranteeLandingPage'),
  },
  [LandingPagePaths.CONVENIENCE]: {
    module: () => import('./convenience/ConvenienceLandingPage'),
  },
  [LandingPagePaths.POINTS_OLD]: {
    module: () => import('./points/PointsLandingPage'),
  },
  [LandingPagePaths.POINTS]: {
    module: () => import('./points/PointsLandingPage'),
  },
  [LandingPagePaths.CAMPUS]: {
    module: () => import('./campus/CampusLandingPage'),
  },
  [LandingPagePaths.GOLD_DAYS]: {
    module: () => import('./goldenDays/GoldDaysProviderWrapper'),
  },
};
